import { logout as logoutApi } from '../api/auth';
import { changeSurveyField } from '../utils/surveys';
import { clearUserDataAction } from './user';
import {
    BUYER_CONFIRM_EMAIL_FIELD,
    BUYER_EMAIL_FIELD,
    BUYER_FIRST_NAME_FIELD,
    BUYER_LAST_NAME_FIELD,
    CANNED_QUESTION_EMAIL_ADDRESS,
    CANNED_QUESTION_FIRST_NAME,
    CANNED_QUESTION_LAST_NAME,
    getFieldName,
} from '../containers/checkout/constants';
import { CHECKOUT_FORM_NAME } from '../constants';

export const logout = () => async (dispatch, getState) => {
    const {
        user: { email, firstName, lastName },
        form: {
            checkoutForm: { values },
        },
        order: { attendees },
    } = getState();
    await logoutApi();
    dispatch(clearUserDataAction());
    dispatch(changeSurveyField(BUYER_EMAIL_FIELD, null, CHECKOUT_FORM_NAME));
    dispatch(
        changeSurveyField(BUYER_CONFIRM_EMAIL_FIELD, null, CHECKOUT_FORM_NAME),
    );
    dispatch(
        changeSurveyField(BUYER_FIRST_NAME_FIELD, null, CHECKOUT_FORM_NAME),
    );
    dispatch(
        changeSurveyField(BUYER_LAST_NAME_FIELD, null, CHECKOUT_FORM_NAME),
    );
    dispatch(changeSurveyField('payment.vaultId', null, CHECKOUT_FORM_NAME));

    const ticketOneFieldValues = values[attendees[0].id];

    if (
        ticketOneFieldValues &&
        ticketOneFieldValues[CANNED_QUESTION_EMAIL_ADDRESS] === email &&
        ticketOneFieldValues[CANNED_QUESTION_FIRST_NAME] === firstName &&
        ticketOneFieldValues[CANNED_QUESTION_LAST_NAME] === lastName
    ) {
        dispatch(
            changeSurveyField(
                getFieldName(attendees[0].id, CANNED_QUESTION_EMAIL_ADDRESS),
                null,
                CHECKOUT_FORM_NAME,
            ),
        );
        dispatch(
            changeSurveyField(
                getFieldName(attendees[0].id, CANNED_QUESTION_FIRST_NAME),
                null,
                CHECKOUT_FORM_NAME,
            ),
        );
        dispatch(
            changeSurveyField(
                getFieldName(attendees[0].id, CANNED_QUESTION_LAST_NAME),
                null,
                CHECKOUT_FORM_NAME,
            ),
        );
    }
};
